import React from "react";
import Typography from "@mui/material/Typography";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import { MzDialog, MzDialogTitle, MzDialogContent, MzDialogActions } from "@markaaz/ui/MzDialogControls";

export default function ConfirmationDialog({ open, handleClose, onConfirm, description }) {
  return (
    <MzDialog open={open} onClose={handleClose}>
      <MzDialogTitle>{I18n.t("common.confirmation")}</MzDialogTitle>
      <MzDialogContent>
        <Typography variant="body1">{description}</Typography>
      </MzDialogContent>
      <MzDialogActions>
        <MzButton variant="outlined" color="secondary" size="large" onClick={handleClose}>
          {I18n.t("common.no")}
        </MzButton>
        <MzButton variant="contained" color="error" size="large" onClick={onConfirm}>
          {I18n.t("common.yes")}
        </MzButton>
      </MzDialogActions>
    </MzDialog>
  );
}
